module.exports = __webpack_public_path__ + "img/dalgona.3f2f2419.png";